import React from 'react';
import '../SuggestedQuestions.css';

/**
 * SuggestedQuestions - Display clickable question chips to guide users
 * Optional onDismiss shows a hide (X) button.
 */
const SuggestedQuestions = ({ questions, onQuestionClick, isLoading, onDismiss }) => {
  if (!questions || questions.length === 0) {
    return null;
  }

  return (
    <div className={`suggested-questions-container ${onDismiss ? 'suggested-questions-can-hide' : ''}`}>
      <div className="suggested-questions-header">
        {onDismiss && (
          <button
            type="button"
            onClick={onDismiss}
            className="suggested-questions-hide"
            aria-label="Hide suggestions"
            title="Hide suggestions"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
              <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        )}
      </div>
      <div className="suggested-questions">
        {questions.map((question) => (
          <button
            key={question.id}
            onClick={() => onQuestionClick(question.text)}
            disabled={isLoading}
            className={`suggestion-chip ${question.category}`}
            aria-label={`Ask: ${question.text}`}
          >
            <span className="chip-icon" style={{ display: 'inline-flex', alignItems: 'center' }}>
              {question.category === 'product' ? (
                <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z" /></svg>
              ) : (
                <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75 2.383a14.406 14.406 0 01-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 10-7.517 0c.85.493 1.509 1.333 1.509 2.316V18" /></svg>
              )}
            </span>
            <span className="chip-text">{question.text}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SuggestedQuestions;
